import { useIngredientsQueries } from "./useIngredientsQueries";

export const useIngredients = ({ recipeId, isCostPricing }) => {
  const { ingredientQuery } = useIngredientsQueries({
    recipeId,
    isCostPricing,
  });
  return { ingredientQuery };
};
